export const kpiDefinitions = {
  ROI: {
    title: "Return On Investment (ROI)",
    type: "formula",
    numerator: "Net Margin $",
    denominator: "(Avg(Shelf Inventory) * Unit Cost) + (Revenue / 12)",
    note: "*Average calculated on 12 months. Revenue / 12 stands for one month of receivables",
  },
  "MINIMUM ROI": {
    title: "Minimum ROI",
    description: "Minimum ROI to achieve provided by Proponent",
  },
  "SERVICE LEVEL": {
    title: "Service Level",
    type: "formula",
    text: "1 - Shelf stockout rate",
  },
  "PNA AVAILABILITY": {
    title: "PNA Availability",
    type: "formula",
    numerator:
      "stock on hand + stock in transit within the lead time - open backorders",
    denominator: "nominal bookings within the lead time",
    note: "*capped at 1",
  },
  "SHELF INVENTORY GROWTH": {
    title: "Shelf Inventory Growth",
    type: "formula",
    numerator: "sum(avg actual shelf inventory * unit cost)",
    denominator: "sum(avg historical shelf inventory * unit cost)",
    suffix: "-1",
    note: "*where the sum is done for all the SKUs in the portfolio and the average is done on the 12 months",
  },
  "GROSS MARGIN": {
    title: "Gross Margin",
    type: "formula",
    text: "(unit price * unit sold) - (unit cost * unit sold) - margin adjusters",
  },
  "NET MARGIN": {
    title: "Net Margin",
    type: "formula",
    text: "Gross margin $ - (inbound costs + outbound costs + carry costs)",
  },
  "TOTAL COST": {
    title: "Total Cost",
    type: "formula",
    text: "Revenue - net margin $",
    note: "*(unit cost * unit sold) + margin adjusters + inbound costs + outbound costs + carry costs",
  },
  "MARGIN ADJUSTERS": {
    title: "Margin Adjusters",
    type: "formula",
    text: "Revenue * (royalty and profit share rate + tariff rate)",
  },
  "INBOUND COSTS": {
    title: "Inbound Costs",
    type: "formula",
    text: "purchase orders placed * placement cost per SKU + receipts * (receiving + inspection + serialization + pre-pak + hazmat cost) + (freight rate * COGS)",
  },
  "OUTBOUND COSTS": {
    title: "Outbound Costs",
    type: "formula",
    text: "unit sold * (sales order placement cost / order size + material cost + packaging labor cost / order size)",
  },
  "CARRY COSTS": {
    title: "Carry Costs",
    type: "formula",
    text: "(space penalty + shelf life penalty + reserve potential) * COGS",
  },
  "INVENTORY COST": {
    title: "Inventory Cost",
    type: "formula",
    text: "Inbound costs + outbound costs + carry costs",
    note: "*operating costs between gross and net margin, not the value of the stock on the shelf",
  },
  "SHELF STOCKOUT RATE": {
    title: "Shelf Stockout Rate",
    type: "formula",
    numerator: "sum(nominal bookings not served from the shelf)",
    denominator: "sum(nominal bookings)",
    note: "*the sum is made over one year.",
  },
  LQ: {
    title: "Line Quantity (LQ)",
    description: "Line quantity calculated by the algorithm",
  },
  ROQ: {
    title: "Reorder Quantity (ROQ)",
    description: "Reorder quantity calculated by the algorithm",
  },
  "ORDERS PER YEAR": {
    title: "Orders per Year",
    description: "Purchase orders placed per year with the selected LQ and ROQ",
  },
  "SAFETY STOCK": {
    title: "Safety Stock",
    type: "formula",
    text: "LQ - nominal bookings within the lead time",
  },
  "FORECAST IN LT": {
    title: "Forecast in Lead Time",
    description:
      "Forecast adjusted demand over the lead time, before applying the win rate",
  },
  "FCST IN LT": {
    title: "Forecast in Lead Time",
    description:
      "Forecast adjusted demand over the lead time, before applying the win rate",
  },
  "TARGET FILL RATE": {
    title: "Target Fill Rate",
    description: "Service target of the FC classification of the SKU",
  },
  "ON HAND AVG QTY": {
    title: "On Hand Avg Qty",
    type: "formula",
    text: "Avg(shelf inventory $) / unit cost",
  },
  "LEAD TIME IN WEEKS": {
    title: "Lead Time in Weeks",
    type: "formula",
    text: "Nominal supplier lead time in days / 7",
  },
  "WR PRIME CUSTOMER": {
    title: "Win Rate Prime Customer",
    description: "Percentage provided by Proponent",
  },
  "WR Prime Customer": {
    title: "Win Rate Prime Customer",
    description: "Percentage provided by Proponent",
  },
  "WR RESELLER": {
    title: "Win Rate Resellers",
    description: "Percentage provided by Proponent",
  },
  "WR Reseller": {
    title: "Win Rate Resellers",
    description: "Percentage provided by Proponent",
  },
  "ACT WR Y-1 RAW": {
    title: "Actual Win Rate Y-1 (Raw)",
    description:
      "Actual win rate for the same month last year, before shrinkage adjustment",
  },
  "FCST WR (avg) RAW": {
    title: "Forecast Win Rate avg (Raw)",
    description: "Average forecast win rate, before shrinkage adjustment",
  },
  "ACT WR Y-1 SHRINKED": {
    title: "Actual Win Rate Y-1 (Shrinked)",
    description:
      "Actual win rate for the same month last year, after shrinkage adjustment",
  },
  "FCST WR (avg) SHRINKED": {
    title: "Forecast Win Rate avg (Shrinked)",
    description: "Average forecast win rate, after shrinkage adjustment",
  },
  "UNIT COST": {
    title: "Unit Cost",
    description: "Unit purchase cost at the ROQ selected",
  },
  "Unit Cost": {
    title: "Unit Cost",
    description: "Unit purchase cost at the ROQ selected",
  },
  "UNIT PRICE": {
    title: "Unit Price",
    description:
      "Weighted average of unit prices at various qty breaks with weights for qty breaks calculated on sales",
  },
  "Unit Price": {
    title: "Unit Price",
    description:
      "Weighted average of unit prices at various qty breaks with weights for qty breaks calculated on sales",
  },
  "Lead Time": {
    title: "Lead Time",
    description: "Nominal supplier lead time, in days",
  },
  // --- GLOBAL CONSTRAINTS ---
  "Maximum Budget": {
    title: "Maximum Budget",
    description: "Maximum allocable budget provided by Proponent",
  },
  "Maximum Perc Unallocated Sku": {
    title: "Maximum % of Unallocated SKU",
    description:
      "Maximum percentage of SKUs left without an allocation, provided by Proponent",
  },
  "Maximum Shelf Inventory Value Growth": {
    title: "Maximum Shelf Inventory $ Growth",
    description: "Maximum shelf inventory $ growth provided by Proponent",
  },
  "Maximum Shelf Stockout Rate": {
    title: "Maximum Shelf Stockout Rate",
    description: "Maximum shelf stockout rate provided by Proponent",
  },
  "Minimum ROI": {
    title: "Minimum ROI",
    description: "Minimum ROI to achieve provided by Proponent",
  },
  "Minimum PNA": {
    title: "Minimum PNA",
    description: "Minimum PNA availability to achieve provided by Proponent",
  },
  "Minimum Revenue": {
    title: "Minimum Revenue",
    description: "Minimum revenue to achieve provided by Proponent",
  },
  "Minimum Service Level": {
    title: "Minimum Service Level",
    type: "formula",
    text: "1 - maximum shelf stockout rate",
  },
  "MINIMUM FILL RATE": {
    title: "Minimum Fill Rate",
    description:
      "Minimum fill rate the family has to achieve, provided by Proponent",
  },
  "Minimum Fill Rate": {
    title: "Minimum Fill Rate",
    description:
      "Minimum fill rate the family has to achieve, provided by Proponent",
  },
  MOQ: {
    title: "Minimum Order Quantity (MOQ)",
    description: "Minimum order quantity provided by Proponent",
  },
  "MAXIMUM POS PER YEAR": {
    title: "Maximum POs per Year",
    description:
      "Maximum number of purchase orders per year provided by Proponent",
  },
  "Max Num of POs Per Year": {
    title: "Maximum POs per Year",
    description:
      "Maximum number of purchase orders per year provided by Proponent",
  },
  REVENUES: {
    title: "Revenue",
    type: "formula",
    text: "unit sold * unit price",
  },
  REVENUE: {
    title: "Revenue",
    type: "formula",
    text: "unit sold * unit price",
  },
  COGS: {
    title: "COGS",
    type: "formula",
    text: "Revenue - gross margin $",
  },
};
